import { render, staticRenderFns } from "./CaseClipsFilter.vue?vue&type=template&id=3008c0c8"
import script from "./CaseClipsFilter.vue?vue&type=script&lang=js"
export * from "./CaseClipsFilter.vue?vue&type=script&lang=js"
import style0 from "./CaseClipsFilter.vue?vue&type=style&index=0&id=3008c0c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports